import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/text-to-image-ai"
    exact
    path="/consumer/features/text-to-image-ai"
    component={AsyncPage}
  />,
];
